import React, {useState} from 'react';
import {Drawer, makeStyles} from "@material-ui/core";
import Icon from '@material-ui/icons/Add';
import Button from '@mui/material/Button';
import ProveedorSocioAgregar from './ProveedorSocioAgregar'

const useStyles = makeStyles((theme) => ({
    paper: {
        width: '28%'
    }
}));

export const BtnAgregarSocio = ({pro}) => {

    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const handleDrawerOpen = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant="contained" size={"small"} style={{color: '#ffffff', backgroundColor: '#123B80'}}
                    onClick={() => setOpen(!open)}>
                <Icon/>
                Agregar
            </Button>
            <Drawer
                classes={{paper: classes.paper}}
                variant="persistent"
                anchor="right"
                open={open}
            >
                <div>
                    <h3>Agregar Socio</h3>
                </div>
                <ProveedorSocioAgregar
                    pro={pro}
                    callbackCloseDrawer={handleDrawerOpen}
                    // callback={props.callbackArt}
                />

            </Drawer>
        </div>
    )
};
export default BtnAgregarSocio;